import { createReducer } from '@reduxjs/toolkit';

import { ModalsModule, ModalsState } from './types';
import {
  hideModalAction,
  showModalAction,
  updateModalParamsAction,
} from './events';

export const defaultState: ModalsState = {
  modalName: null,
  params: null,
  containerId: 'global',
};

const modalsModule: ModalsModule = () => ({
  name: 'modals',
  reducer: createReducer(defaultState, (builder) =>
    builder
      .addCase(hideModalAction, () => defaultState)
      .addCase(
        showModalAction,
        (_, { payload: { modalName, params, containerId = 'global' } }) => ({
          modalName,
          params,
          containerId,
        }),
      )
      .addCase(
        updateModalParamsAction,
        (state, { payload: { params, rewrite } }) => ({
          ...state,
          params: rewrite ? params : { ...state.params, ...params },
        }),
      ),
  ),
  api: {
    handleClose: (_, { dispatch }) => {
      dispatch(hideModalAction());
    },
  },
});

export default modalsModule;
